module.exports = __webpack_public_path__ + "img/i_empty.f34ada33.svg";